<div class="min-wx-256" *ngLet="searchString$ | async as searchString">
  <ng-select #globalSearch id="globalSearch" class="select-sm dropdown-long dropdown-wide-center dropdown-gap tags-only ng-select-dark" bindLabel="DisplayName" bindValue="Id" appendTo="body"
             placeholder="Search (Alt+Q)" [class.ng-has-searchterm]="searchString"
             groupBy="Results"
             [items]="groupedResults"
             [virtualScroll]="false"
             [searchFn]="searchFn"
             [loading]="true"
             [(ngModel)]="model"
             (search)="search($event)"
             (clear)="search(null)"
             (change)="onChange($event)"
             (focus)="globalSearch.placeholder = 'Search'; globalSearch.loading = false"
             (blur)="globalSearch.placeholder = 'Search (Alt+Q)'; globalSearch.loading = true"
             (paste)="onPaste($event)">
    <ng-template ng-loadingspinner-tmp>
      <svg viewBox="0 0 8 8" class="icon small me-1 text-default" [inlineSVG]="'#magnifying-glass'"></svg>
    </ng-template>
    <ng-template ng-header-tmp let-search="searchTerm">
      <div *ngIf="searchString" class="w-100" style="background-color: #4c4c4c; color: rgb(221, 221, 221)">
        <div *ngIf="search == null" (click)="globalSearch.searchTerm = searchString" class="me-auto m-1" style="cursor: pointer">
          <span class="pi pi-history"></span>
          {{searchString}}
        </div>
      </div>
    </ng-template>
    <ng-template ng-optgroup-tmp let-item="item">
      <ng-container *ngIf="item.Type !== 999; else favouritesGroupTmpl">
        <a (click)="toggleGroupFilter(item.Type)">
          <svg viewBox="0 0 8 8" class="icon small me-1 text-default" [inlineSVG]="item.Results.length ? '#chevron-down' : '#chevron-right'"></svg>
          <span class="badge" [ngClass]="item.CssClass">
            {{item.Name}}
          </span>
        </a>
        <span class="ms-1 text-gray-400">
        {{item.Length}}<ng-container *ngIf="item.Length === 100">+</ng-container>
      </span>
      </ng-container>
      <ng-template #favouritesGroupTmpl>
        <svg viewBox="0 0 8 8" class="icon small me-1 text-orange-400" [inlineSVG]="'#star'"></svg>
        <span class="badge" [ngClass]="item.CssClass">
          {{item.Name}}
        </span>
      </ng-template>
    </ng-template>
    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
      <ng-container [ngTemplateOutlet]="itemTemplate" [ngTemplateOutletContext]="{item: item, index: index, searchTerm: search, select: globalSearch}">
      </ng-container>
    </ng-template>
  </ng-select>
</div>

<ng-template #itemTemplate let-searchTerm="searchTerm" let-item="item" let-select="select">
  <div class="d-flex justify-content-between text-wrap text-break ms-n5 ps-1 bl-4" *ngIf="item.Type !== 999; else favouriteTmpl"
       [class.border-secondary]="item.Type === entityTypes.Item"
       [class.border-primary]="item.Type === entityTypes.ItemGroup"
       [class.border-info]="item.Type === entityTypes.Resource"
       [class.border-left-indigo-400]="item.Type === entityTypes.Property"
       (click)="$event.stopPropagation()">
    <div>
      <span [ngOptionHighlight]="searchTerm" (click)="open(item, 'default'); $event.stopPropagation(); select.close()" class="flex-grow-1">
      {{item | displayName}}
      </span>
      <span *ngIf="item.IsDraft" class="badge bg-default" title="Draft">D</span>
    </div>
    <div class="my-auto m-1">
      <a class="show-on-option-hover" (click)="open(item, 'blank'); select.close()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
      </a>
      <a class="show-on-option-hover mt-1" (click)="open(item, 'modal'); select.close()">
        <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#computer-desktop"></svg>
      </a>
    </div>
  </div>
  <ng-template #favouriteTmpl>
    <div class="d-flex justify-content-between text-wrap text-break ms-n5 ps-1 bl-4 border-warning"
         (click)="openFavourite(item, 'default'); $event.stopPropagation(); select.close()">
    <span [ngOptionHighlight]="searchTerm">
      {{item | displayName}}
    </span>
      <div class="my-auto">
        <a class="show-on-option-hover me-1" (click)="openFavourite(item, 'blank'); select.close()">
          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#arrow-top-right-on-square"></svg>
        </a>
      </div>
    </div>
  </ng-template>
</ng-template>
